import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  isOpen: boolean
  onClose: () => void
  webformId?: number
  contactId: number
  contactFullName: string
}

const ContactMergeModal = ({ isOpen, webformId, contactId, contactFullName, onClose }: Props) => {
  const onContactSelected = (contact: server.dto.ContactSmallV2) => {
    if (webformId) {
      window.location.href = `${routes.contact_Merge(contactId, contact.contactId).absolute}?fromWebformId=${webformId}`;
    } else {
      window.location.href = routes.contact_Merge(contactId, contact.contactId).absolute;
    }
    onClose();
  };

  return <>
    {isOpen && <ContactModalPicker
      title={RESX.OptionsPanel.Merge}
      initialKeyword={contactFullName}
      canCreateNew={false}
      excludeKeys={[contactId]}
      nonInPageEditing={{
        onChange: onContactSelected,
        startOpen: true,
        value: undefined,
        required: false,
        validatorKey: "contactModalPicker",
      }}
    />}
  </>;
};

export default ContactMergeModal;